import { configureStore } from '@reduxjs/toolkit';
/*import { createMiddleware } from 'redux-beacon';
import GoogleAnalytics from '@redux-beacon/google-analytics';
import logger from '@redux-beacon/logger';*/

import socketIoMiddleware from './middleware/socketIoMiddleware';
import nativeWebSocketMiddleware from './middleware/nativeWebSocketMiddleware';
import analyticsMiddleware from './middleware/analyticsMiddleware';

import { userSlice } from '../features/user/UserSlice';
import { assetsSlice } from '../features/assets/assetsSlice';
import { layoutSlice } from '../features/layout/layoutSlice';
import { mapSlice } from '../features/map/mapSlice';
import { placesSlice } from '../features/places/placesSlice';
import { eventsSlice } from '../features/events/eventsSlice';
import { historySlice } from '../features/datacenter/historySlice';
import { reportSlice } from '../features/datacenter/reportSlice';
import { fuelSlice } from '../features/fueladmin/fuelSlice';
import { dieselPriceSlice } from '../features/dieselprice/dieselPriceSlice';
import { gensetSlice } from '../features/genset/gensetSlice';
import { subaccountSlice } from '../features/subaccounts/subaccountSlice';
import { tripViewSlice } from '../features/tripcenter/tripViewSlice';
import { tripControlSlice } from '../features/tripcenter/tripControlSlice';
import { routeSlice } from '../features/tripcenter/routeSlice';
import { googleRouteMakerSlice } from '../features/tripcenter/googleRouteMakerSlice';

/*import eventsMap from './analyticsEvents';
const ga = GoogleAnalytics();
const analyticsMiddleware = createMiddleware(eventsMap, ga, { logger });*/

//console.log('Initializing Redux store...');

const socketMiddleware = process.env.REACT_APP_SOCKET_TRANSPORT === 'socketio'
  ? socketIoMiddleware
  : nativeWebSocketMiddleware;

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    assets: assetsSlice.reducer,
    layout: layoutSlice.reducer,
    map: mapSlice.reducer,
    places: placesSlice.reducer,
    events: eventsSlice.reducer,
    history: historySlice.reducer,
    reports: reportSlice.reducer,
    fuel: fuelSlice.reducer,
    dieselPrice: dieselPriceSlice.reducer,
    genset: gensetSlice.reducer,
    subaccount: subaccountSlice.reducer,
    tripView: tripViewSlice.reducer,
    tripControl: tripControlSlice.reducer,
    route: routeSlice.reducer,
    googleRouteMaker: googleRouteMakerSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    //console.log('Configuring middleware...');
    const middleware = getDefaultMiddleware().concat(
      socketMiddleware(),
      analyticsMiddleware(),
    );
    //console.log('Middleware configured:', middleware);
    return middleware;
  },
  //devTools: process.env.NODE_ENV !== 'production',
});

//console.log('Redux store initialized');

// Add store subscription for debugging
/* store.subscribe(() => {
  console.log('Store state updated:', store.getState());
}); */
